import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Tag from '4all-ui/components/Tag';
import { styles, mixins } from '4all-ui/styles';
import { GRAY_DARKER, MAIN_COLOR, GRAY_LIGHTER } from '../../styles/variables';

const TagListContainer = styled.div`
  ${mixins.flexPosition({ align: 'center', justify: 'flex-start' })}
  flex-wrap: wrap;
`;

const getTagStyle = tag => {
  let tagStyles = null;
  const { active } = tag;
  tagStyles = {
    color: active ? '#FFF' : GRAY_DARKER,
    bgColor: active ? MAIN_COLOR : 'transparent',
    border: active ? `1px solid ${MAIN_COLOR}` : `1px solid ${GRAY_LIGHTER}`,
  };

  return tagStyles;
};

const hoverStyles = tag => ({
  cursor: !tag.disabled ? 'pointer' : 'not-allowed',
});

const SelectableTagList = ({ tags, selectTag, onHoverTag, onBlurTag }) => {
  return (
    <TagListContainer>
      {tags.map(tag => (
        <Tag
          key={`tag-id-${tag.label}`}
          id={`tag-selectable-mktpc-${tag.label.toLowerCase()}`}
          tag={tag}
          disabled={tag.disabled}
          onClick={() => selectTag(tag)}
          {...getTagStyle(tag)}
          hoverStyle={hoverStyles(tag)}
          customStyles={{
            textTransform: 'capitalize',
            cursor: 'pointer',
            fontSize: styles.fontSizes.SIZE_7,
          }}
          onHoverTag={onHoverTag}
          onBlurTag={onBlurTag}
        >
          {tag.label}
        </Tag>
      ))}
    </TagListContainer>
  );
};

SelectableTagList.propTypes = {
  tags: PropTypes.array,
  selectTag: PropTypes.func,
  onHoverTag: PropTypes.func,
  onBlurTag: PropTypes.func,
};

export default SelectableTagList;



// WEBPACK FOOTER //
// ./src/components/SelectableTagList/index.js